import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import LadgerHome from './LadgerHome';
import { Breadcrumbs } from '../../AbstractElements';
import React, { Fragment } from 'react'

export default function LadgerList() {
    return (
        <Fragment>
            
            <Breadcrumbs mainTitle="List of Customer Ledgers" parent="Home" title="List of Customer Ledgers" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <LadgerHome />
                    </Col>
                </Row>
            </Container>

        </Fragment>
    )
}
